<template>
  <div
    class="switch-version-box"
    v-if="showSwitchVersion"
    @click="switchVersion"
  >
    <a href="javascript:;" class="switch-version-btn">
      <div class="switch-version-btn-text" :class="[lang]">
        <p>{{ letter.switchNewVersion }}</p>
        <p>{{ letter.switchNewVersionPlatform }}</p>
      </div>
    </a>
  </div>
</template>

<script>
import switchVersion from '@mixins/officialWebStore/switchVersion';
export default {
  mixins: [switchVersion],
  name: 'SwitchVersion',
  computed: {
    letter() {
      return this.$store.state.letter;
    },
    lang() {
      return this.$store.state.lang;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialWebStore/_dimen.scss';
.switch-version-box {
  position: fixed;
  z-index: 9;
  height: 50px;
  right: 0;
  top: 370px;
}

.switch-version-btn {
  float: right;
  width: 168px;
  height: 205px;
  background: url($tmslgImg + 'm-switch-version.png') no-repeat;
  background-size: cover;
  cursor: pointer;
  &-text {
    margin-top: 98px;
    user-select: none;
    &.vi-VN,
    &.it-IT {
      margin-top: 86px;
    }
    &.zh-CN,
    &.zh-TW {
      margin-top: 106px;
    }
    &.pt-PT {
      margin-top: 88px;
    }
    p {
      display: block;
      text-align: center;
      font-size: 22px;
      line-height: 20px;
      padding: 0 8px;
      // 文字渐变色
      font-weight: bold;
      -webkit-background-clip: text;
      color: transparent; /* Fallback for non-webkit browsers */
      background-clip: text;
      -webkit-text-fill-color: transparent;
      background-image: linear-gradient(to bottom, #ffe070, #ffffff);
      &:nth-child(1) {
        margin-bottom: 8px;
      }
    }
  }
}
</style>
